export default {
  isAuthenticated: true
}